import Loader from "components/Loader";
import Header from "components/Modal/Header";
import Text from "components/Text";
import { useEffect } from "react";
import theme from "theme";
import { MyJobCard } from "./MyJobCard";
import {
    CardsColumn,
    CountsWrapper,
    HeaderText,
    JobListWrapper,
    NoDataContentCenter,
    RightSection,
} from "./MyJobListings.styled";
import { AgencyJob } from "./types";
import { useMyJobListings } from "./useMyJobListings";
type MyJobListingsProps = {
    type: string;
};

const MyJobListings = ({ type }: MyJobListingsProps) => {
    const { agencyJobs, refetch, agencyJobCount, isJobsLoading } =
        useMyJobListings(type);
    useEffect(() => {
        refetch();
    }, [refetch, type]);

    return (
        <JobListWrapper>
            <RightSection>
                {isJobsLoading && <Loader size={28} />}
                {!isJobsLoading && (
                    <>
                        <Header>
                            <HeaderText>
                                <Text
                                    variant="heading5"
                                    fontWeight="700"
                                    color={theme.colors.text}
                                >
                                    Find Work
                                </Text>
                                <CountsWrapper>
                                    <Text
                                        variant="label"
                                        color={theme.colors.green.primary}
                                    >
                                        {agencyJobCount} Matching
                                    </Text>
                                    <Text
                                        className="resultsText"
                                        variant="label"
                                        color={theme.colors.text}
                                    >
                                        call opportunities
                                    </Text>
                                </CountsWrapper>
                            </HeaderText>
                            {/* <SingleSelect
                                label="Sort By"
                                value="Relevance"
                                options={[
                                    {
                                        label: "Relevance",
                                        value: "Relevance",
                                    },
                                    {
                                        label: "Most Recent",
                                        value: "Most Recent",
                                    },
                                ]}
                                placeholder="Relevance"
                            /> */}
                        </Header>
                        {agencyJobs?.length > 0 && (
                            <CardsColumn key={type}>
                                {agencyJobs.map((job: AgencyJob) => {
                                    return <MyJobCard key={job.id} job={job} />;
                                })}
                            </CardsColumn>
                        )}
                        {agencyJobs?.length === 0 && (
                            <NoDataContentCenter>
                                <Text variant="heading3">No Data Found.</Text>
                            </NoDataContentCenter>
                        )}
                    </>
                )}
            </RightSection>
        </JobListWrapper>
    );
};

export default MyJobListings;
